import React from 'react'
import { connect } from 'react-redux'
import { bindActionCreators } from 'redux'
import { Typography } from '@material-ui/core'
import { Add } from '@material-ui/icons'
import { addStage, addStageSuccess } from 'actions/campaign/addOrEdit'
import { createOrUpdateCampaign } from 'actions/campaign'
import language from 'utils/vast-languagepack'

export default connect(
	(state) => ({ status: state.campaign.addOrEdit.campaign.status }),
	(dispatch) =>
		bindActionCreators(
			{ addStage, createOrUpdateCampaign, addStageSuccess },
			dispatch,
		),
)(
	({
		classNames,
		addStage,
		createOrUpdateCampaign,
		status,
		typographyClassname,
		addStageSuccess,
	}) => {
		const color = status === 'L' || status === 'C' ? '#49466a' : '#034c94'
		const cursor = status === 'L' || status === 'C' ? 'auto' : 'pointer'

		return (
			<div
				style={{
					position: 'relative',
					width: '100%',
					marginTop: 15,
				}}
				onClick={() => {
					if (status !== 'L' && status !== 'C') {
						Promise.resolve(addStage())
							.then(() => createOrUpdateCampaign())
							.then((payload) => addStageSuccess(payload))
					}
				}}
			>
				<div
					style={{
						border: `1.5px dashed ${color}`,
						cursor,
					}}
					className={classNames}
				>
					<Add style={{ width: 16, verticalAlign: 'sub', color }} />
					<Typography
						className={typographyClassname}
						style={{ color, display: 'inline-block' }}
					>
						{language.campaign.add.addFunnelStage}
					</Typography>
				</div>
			</div>
		)
	},
)
